import React from 'react';
import type { PaletteRole } from '../lib/permissions';

interface PaletteRoleBadgeProps {
  role: PaletteRole | null;
  isPublic?: boolean;
  size?: 'sm' | 'md';
}

export const PaletteRoleBadge: React.FC<PaletteRoleBadgeProps> = ({
  role,
  isPublic = false,
  size = 'sm',
}) => {
  if ((!role || role === 'owner') && !isPublic) return null;

  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';

  const roleConfig: Record<PaletteRole, { color: string; icon: string; label: string }> = {
    owner: {
      color: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
      icon: '👑',
      label: 'Owner',
    },
    editor: {
      color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
      icon: '✏️',
      label: 'Editor',
    },
    viewer: {
      color: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
      icon: '👁️',
      label: 'Viewer',
    },
  };

  return (
    <div className="flex items-center gap-1">
      {role && (
        <span
          className={`inline-flex items-center gap-1 rounded-full font-medium ${sizeClasses} ${roleConfig[role].color}`}
        >
          <span>{roleConfig[role].icon}</span>
          <span>{roleConfig[role].label}</span>
        </span>
      )}
      {isPublic && (
        <span
          className={`inline-flex items-center gap-1 rounded-full font-medium ${sizeClasses} bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300`}
          title="This palette is publicly accessible"
        >
          <span>🌐</span>
          <span>Public</span>
        </span>
      )}
    </div>
  );
};
